import { memo } from 'react'
import isEqual from 'react-fast-compare'
import styled from 'styled-components'

import { decodeHtml } from '@nx/decode-html'
import { Label } from '@nx/fire/typography'
import { buildPriceString } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import translate from './OutbidLabel.translate.json'

const { text } = getTranslate(translate)

export const OutbidLabel = memo(
  ({ currencySymbol, price, ...props }: OutbidLabelProps) => (
    <>
      <StyledOutbidLabelLabel $level="M" {...props}>
        {text('outbid')}
      </StyledOutbidLabelLabel>
      <StyledOutbidPriceLabel $level="M" {...props}>
        {text('outbidPrice', {
          price: buildPriceString({
            currencySymbol: decodeHtml(currencySymbol),
            lowPrice: price,
          }),
        })}
      </StyledOutbidPriceLabel>
    </>
  ),
  isEqual
)

export const StyledOutbidLabelLabel = styled(Label)`
  margin-bottom: 15px;
`

export const StyledOutbidPriceLabel = styled(Label)`
  /* Empty for override styles */
`

export interface OutbidLabelProps {
  currencySymbol: string
  price: number
}
